import { Dispatch } from 'react';
import { PaginateList } from 'src/app/common/types';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import { getQueryPath } from 'src/app/common/utils';
import { AdminReportBatchFileListItem } from '../types/opm-pd-admin-report-types';

const opmPdAdminReportEndpoint = 'opm-pd/admin-report/';

export type FetchAdminReportBatchFilesParams = {
  page: number;
  limit: number;
  sort?: string;
  batchNo?: string;
  submittedAtFrom?: string;
  submittedAtTo?: string;
  submittedBy?: string;
};

export const fetchAdminReportBatchFiles = async (
  params: FetchAdminReportBatchFilesParams,
  dispatch?: Dispatch<any>,
): Promise<PaginateList<AdminReportBatchFileListItem>> => {
  // const queryPath = getQueryPath(`${ADMIN_URL}/${opmPdAdminReportEndpoint}batch-files?`, params);
  const url = `${ADMIN_URL}/${opmPdAdminReportEndpoint}batch-files`;
  return apiClient
    .get(url, {
      params: {
        ...params,
      },
    })
    .then((response) => {
      return response.data.data as PaginateList<AdminReportBatchFileListItem>;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const exportAdminReportBatchFileSubmittedPolicies = async (
  params: { batchIds: string[] },
  dispatch?: Dispatch<any>,
): Promise<Blob> => {
  const queryPath = getQueryPath(
    `${ADMIN_URL}/${opmPdAdminReportEndpoint}batch-files/export-submitted-policies?`,
    params,
  );
  return apiClient
    .get<Blob>(queryPath)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const exportAdminReportBatchFileFinalPolicies = async (
  params: { batchIds: string[] },
  dispatch?: Dispatch<any>,
): Promise<Blob> => {
  const queryPath = getQueryPath(`${ADMIN_URL}/${opmPdAdminReportEndpoint}batch-files/export-final-policies?`, params);
  return apiClient
    .get<Blob>(queryPath)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
